import React, { useState } from 'react';
import { Button, Notice, PageHeader, TextInput } from '@origo/origo-ui';
import { PlugIcon } from '@phosphor-icons/react';
import { useApi } from '../../api/ApiContext';
import { ApiError } from '../../api/client';
import styles from '../common/panel.module.css';

type TestState = { status: 'idle' | 'testing' | 'ok' | 'fail'; message?: string };

export const SettingsPanel: React.FC = () => {
    const { client, baseUrl, setBaseUrl } = useApi();
    const [baseUrlInput, setBaseUrlInput] = useState(baseUrl);
    const [test, setTest] = useState<TestState>({ status: 'idle' });

    const saveBaseUrl = () => setBaseUrl(baseUrlInput.trim());

    const runTest = async () => {
        setTest({ status: 'testing' });
        try {
            const info = await client.getServiceInfo();
            const health = await client.getHealth();
            setTest({
                status: 'ok',
                message: `${info.service} — ${info.status}. Helse: healthz=${health.healthz ? 'OK' : 'nede'}, readyz=${health.readyz ? 'klar' : 'ikke klar'}.`,
            });
        } catch (err) {
            const message = err instanceof ApiError ? err.message : 'Fikk ikke kontakt med API-et.';
            setTest({ status: 'fail', message });
        }
    };

    return (
        <>
            <PageHeader
                title="Innstillinger"
                description="API-tilkobling for forvaltning-api."
            />

            <div className={styles.scroll}>
                <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>API-tilkobling</h3>
                    <TextInput
                        label="Base-URL"
                        value={baseUrlInput}
                        onChange={(e) => setBaseUrlInput(e.target.value)}
                        placeholder="https://<kunde>.<miljø>.forvaltning.<cluster>.geodataonline.no"
                        helperText="URL til forvaltning-api uten avsluttende skråstrek. Hentes fra app-innstillingene (apiBaseUrl) per kunde, f.eks. https://venus.dev.forvaltning.origo-test-venus.geodataonline.no. Overstyr her kun for lokal testing (http://localhost:5022)."
                    />
                    <div className={styles.rowActions}>
                        <Button variant="secondary" size="sm" onClick={saveBaseUrl} disabled={baseUrlInput.trim() === baseUrl}>
                            Lagre URL
                        </Button>
                        <Button
                            variant="primary"
                            size="sm"
                            leftIcon={<PlugIcon size={16} weight="bold" />}
                            onClick={runTest}
                            disabled={test.status === 'testing'}
                        >
                            {test.status === 'testing' ? 'Tester…' : 'Test tilkobling'}
                        </Button>
                    </div>
                    {test.status === 'ok' && <Notice variant="success">{test.message}</Notice>}
                    {test.status === 'fail' && <Notice variant="danger">{test.message}</Notice>}
                </div>
            </div>
        </>
    );
};
